// APP PORTAL
const BTN_PORTAL_LOGIN = 'btn_portal_login'
const BTN_PORTAL_FORGOT_PASSWORD = 'btn_portal_forgot_password'
const BTN_PORTAL_DASHBOARD_FLEET_MANAGEMENT =
  'btn_portal_dashboard_fleet_management'
const BTN_PORTAL_DASHBOARD_LIVE_TRACKING = 'btn_portal_dashboard_live_tracking'
const BTN_PORTAL_DASHBOARD_REPORTS = 'btn_portal_dashboard_reports'
const BTN_PORTAL_HEADER_NINE_CIRCLE_MENU = 'btn_portal_header_nine_circle_menu'
const BTN_PORTAL_SIDEBAR_MENU_ACCOUNT_SETTINGS =
  'btn_portal_sidebar_menu_account_settings'
const BTN_PORTAL_MENU_AND_SERVICES_MY_BILLS =
  'btn_portal_menu_and_services_my_bills'
const BTN_PORTAL_MENU_AND_SERVICES_HELP_CENTER =
  'btn_portal_menu_and_services_help_center'
const BTN_PORTAL_MENU_AND_SERVICES_MY_PROFILE =
  'btn_portal_menu_and_services_my_profile'

// FLEET MANAGEMENT
const BTN_FLEET_MANAGEMENT_SEE_DETAIL = 'btn_fleet_management_see_detail'
const INP_FLEET_MANAGEMENT_MODIFY_NAME_THING =
  'inp_fleet_management_modify_name_thing'
const INP_FLEET_MANAGEMENT_MODIFY_KM_THING =
  'inp_fleet_management_modify_km_thing'
const INP_FLEET_MANAGEMENT_PERSONS_SEARCH =
  'inp_fleet_management_persons_search'
const BTN_FLEET_MANAGEMENT_ADD_PERSON = 'btn_fleet_management_add_person'
const INP_FLEET_MANAGEMENT_ADD_ROL = 'inp_fleet_management_add_rol'
const BTN_FLEET_MANAGEMENT_ADD_ZONE = 'btn_fleet_management_add_zone'
const BTN_FLEET_MANAGEMENT_EDIT_ZONE = 'btn_fleet_management_edit_zone'
const INP_FLEET_MANAGEMENT_TYPE_ZONE = 'inp_fleet_management_type_zone'
const BTN_FLEET_MANAGEMENT_AGENTS_TABLE_ADD =
  'btn_fleet_management_agents_table_add'
const INP_FLEET_MANAGEMENT_AGENTS_SEARCH = 'inp_fleet_management_agents_search'
const BTN_FLEET_MANAGEMENT_AGENT_EDIT = 'btn_fleet_management_agent_edit'
const INP_FLEET_MANAGEMENT_AGENT_CONDITION =
  'inp_fleet_management_agent_condition'
const INP_FLEET_MANAGEMENT_AGENT_TOLERANCE =
  'inp_fleet_management_agent_tolerance'
const BTN_FLEET_MANAGEMENT_AGENT_COMBINED =
  'btn_fleet_management_agent_combined'
const BTN_FLEET_MANAGEMENT_AGENT_ADD_RESTRICTION =
  'btn_fleet_management_agent_add_restriction'
const INP_FLEET_MANAGEMENT_AGENT_ADD_ENTITIES =
  'inp_fleet_management_agent_add_entities'
const INP_FLEET_MANAGEMENT_AGENT_ADD_RECIPIENTS =
  'inp_fleet_management_agent_add_recipients'
const INP_FLEET_MANAGEMENT_AGENT_TYPE_NOTIFICATIONS =
  'inp_fleet_management_agent_type_notifications'

// LIVE TRACKING
const BTN_LIVE_TRACKING_ENTITIES = 'btn_live_tracking_entities'
const BTN_LIVE_TRACKING_ENTITY_MODAL = 'btn_live_tracking_entity_modal'
const BTN_LIVE_TRACKING_ENITITY_FOLLOW = 'btn_live_tracking_entity_follow'
const BTN_LIVE_TRACKING_NOTIFICATIONS = 'btn_live_tracking_notifications'
const BTN_LIVE_TRACKING_HISTORICAL_TOUR = 'btn_live_tracking_historical_tour'
const BTN_LIVE_TRACKING_HISTORICAL_TOUR_SUMMARY =
  'btn_live_tracking_historical_tour_summary'
const BTN_LIVE_TRACKING_CERTIFICATE = 'btn_live_tracking_certificate'

export default {
  BTN_PORTAL_DASHBOARD_FLEET_MANAGEMENT,
  BTN_PORTAL_DASHBOARD_LIVE_TRACKING,
  BTN_PORTAL_DASHBOARD_REPORTS,
  BTN_PORTAL_FORGOT_PASSWORD,
  BTN_PORTAL_HEADER_NINE_CIRCLE_MENU,
  BTN_PORTAL_LOGIN,
  BTN_PORTAL_SIDEBAR_MENU_ACCOUNT_SETTINGS,
  BTN_PORTAL_MENU_AND_SERVICES_MY_BILLS,
  BTN_PORTAL_MENU_AND_SERVICES_HELP_CENTER,
  BTN_PORTAL_MENU_AND_SERVICES_MY_PROFILE,
  BTN_LIVE_TRACKING_ENTITIES,
  BTN_LIVE_TRACKING_ENTITY_MODAL,
  BTN_LIVE_TRACKING_ENITITY_FOLLOW,
  BTN_LIVE_TRACKING_NOTIFICATIONS,
  BTN_LIVE_TRACKING_HISTORICAL_TOUR,
  BTN_LIVE_TRACKING_HISTORICAL_TOUR_SUMMARY,
  BTN_LIVE_TRACKING_CERTIFICATE,
  BTN_FLEET_MANAGEMENT_SEE_DETAIL,
  INP_FLEET_MANAGEMENT_MODIFY_NAME_THING,
  INP_FLEET_MANAGEMENT_MODIFY_KM_THING,
  INP_FLEET_MANAGEMENT_PERSONS_SEARCH,
  BTN_FLEET_MANAGEMENT_ADD_PERSON,
  INP_FLEET_MANAGEMENT_ADD_ROL,
  BTN_FLEET_MANAGEMENT_ADD_ZONE,
  BTN_FLEET_MANAGEMENT_EDIT_ZONE,
  INP_FLEET_MANAGEMENT_TYPE_ZONE,
  BTN_FLEET_MANAGEMENT_AGENTS_TABLE_ADD,
  INP_FLEET_MANAGEMENT_AGENTS_SEARCH,
  BTN_FLEET_MANAGEMENT_AGENT_EDIT,
  INP_FLEET_MANAGEMENT_AGENT_CONDITION,
  INP_FLEET_MANAGEMENT_AGENT_TOLERANCE,
  BTN_FLEET_MANAGEMENT_AGENT_COMBINED,
  BTN_FLEET_MANAGEMENT_AGENT_ADD_RESTRICTION,
  INP_FLEET_MANAGEMENT_AGENT_ADD_ENTITIES,
  INP_FLEET_MANAGEMENT_AGENT_ADD_RECIPIENTS,
  INP_FLEET_MANAGEMENT_AGENT_TYPE_NOTIFICATIONS
}
